<template>
  <z-container>

    <z-loading :loading="loading"></z-loading>

    <v-card v-show="!loading">
      <v-toolbar flat color="white">

        <v-btn icon color="primary" :to="{name: 'FornecedoresLista'}" exact>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="text-subtitle-1">Produtos Fornecedor</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn id="btAtualizar" icon @click="refresh" :loading="listando">
          <v-icon>refresh</v-icon>
          <v-tooltip bottom activator="#btAtualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
        <v-btn depressed small color="primary" @click="$refs.DialogoBuscaProdutos.abrir()" :disabled="!$auth.temPermissao('fornecedores.produtos_adicionar')">
          <v-icon left>mdi-plus</v-icon>Adicionar Produto
        </v-btn>
        
      </v-toolbar>

      <v-divider></v-divider>
      
      <v-card-text class="text-h6">
        {{ `${fornecedor.id} - ${fornecedor.razao}`}}
      </v-card-text>

      <v-divider></v-divider>

      <v-data-table 
        :headers="headers" 
        :items="fornecedor.produtos" item-key="id" 
        :loading="listando" 
        :search="search"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item="{item: produto, index}">
          <tr>
            <td>{{ produto.referencia }}</td>
            <td>{{ produto.descricao }}</td>
            <td class="text-center">
              <v-btn icon @click="perguntarRemover(produto, index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>


    <dialogo-buscar-produtos ref="DialogoBuscaProdutos" @busca:selecionar="selecionarProduto"></dialogo-buscar-produtos>

    <z-dialogo-sim-nao ref="dialogoRemoverProduto" titulo="Remover produto da lista?" botaoSim="Remover" botaoNao="Cancelar">
      O produto será removido da lista deste fornecedor.
    </z-dialogo-sim-nao>

  </z-container>
</template>

<script>

  import apiFornecedores from "@/app/services/fornecedores";
  import apiProdutos from "@/app/services/produtos";

  export default {
    name: 'ProdutosFornecedor',

    data() {
      return {
        fornecedor: {
          id: '',
          razao: '',
          produtos: [],
        },
        search: '',
        headers: [
          { text: "Referência", value: "referencia", width: "150px" },
          { text: "Descrição", value: "descricao" },
          { text: "Opções", value: "", width: "200px", align: "center" }
        ],
        loading: false,
        listando: false,
      }
    },

    async mounted () {
      if (this.$route.params.id) {
        this.loading = true;
        await this.carregarProdutosFornecedor(this.$route.params.id);
        this.loading = false;
      };
    },

    methods: {
      refresh() {
        this.carregarProdutosFornecedor(this.$route.params.id);
      },

      async carregarProdutosFornecedor(id) {
        this.listando = true;
        this.fornecedor = await apiFornecedores.listarProdutosFornecedor(id);
        this.listando = false;
      },

      selecionarProduto(produto) {
        produto.referencia;
        produto.descricao;

        this.atualizarProduto(produto);

        this.fornecedor.produtos.push(produto);
      },

      async atualizarProduto(produto) {

        let dados = {
          produto_id: produto.id,
          fornecedor_id: this.fornecedor.id
        }

        await apiProdutos.atualizarFornecedorProduto(dados);
      },

      perguntarRemover(produto, index) {

        this.$refs.dialogoRemoverProduto.abrir()
          .then(async response => {

            if (response == true) {
              let dados = {
                produto_id: produto.id,
                fornecedor_id: null
              }

              await apiProdutos.atualizarFornecedorProduto(dados);

              this.fornecedor.produtos.splice(index, 1);
            }
          })
      }
    },
  }
</script>

<style scoped>

</style>